import {
  Box,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import _ from 'lodash';
import {
  PrimaryButton,
  TableButton,
} from '../../../components/style/ButtonStyle';
import {
  MaxWidthCell,
  PrettyScrollbarTableWrap,
  PrimaryBorderTable,
} from '../../../components/style/TableStyle';
import { FormTitle } from '../../../components/style/TextStyle';
import { AddButtonIcon } from '../../../layouts/dashboard/nav/IconButton';

import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Empty from '../../../components/common/Empty';
import { DetailedSearch } from '../../../components/search-input/DetailedSearchBar';
import { useAuthAxios } from '../../../hooks/useAuthAxios';
import useResponsive from '../../../hooks/useResponsive';
import { useYupValidationResolver } from '../../../hooks/useYupValidationResolver';
import { fDate } from '../../../utils/formatTime';
import AddCategoryButton from './Common/AddCategoryButton';
import { CreateDepartmentForm } from './Common/CreateCategoryForm';
import DeleteCategoryButton from './Common/DeleteButton';
import EditCategoryButton from './Common/EditCategoryButton';
import { EditDepartmentForm } from './Common/EditCategoryForm';
import { departmentHeader } from './header';
import {
  departmentDefaultValue,
  departmentSchema,
} from './Common/DefaultValuesAndSchema';

export default function DepartmentCategory() {
  const [search, setSearch] = useState('');
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();
  const [getDepartmentsResult, getDepartments] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/department`,
      params: {
        title: search,
      },
    },
    { manual: false },
  );
  const departments = _.get(getDepartmentsResult, 'response.data.result');
  const isEmpty = _.isEmpty(departments);

  useEffect(() => {
    getDepartments();
  }, [getDepartments]);

  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...departmentSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...departmentDefaultValue,
    },
    shouldUnregister: false,
  });

  const [postDepartmentResult, postDepartment] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/department',
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      description: values.description,
    };
    postDepartment({ data: payload });
  });

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {mdUp ? <FormTitle>부서 목록</FormTitle> : <Box />}
        {mdUp ? (
          <AddCategoryButton
            label="관리부서 추가"
            form={form}
            onSubmit={onSubmit}
            children={<CreateDepartmentForm form={form} />}
            postResult={postDepartmentResult}
            getResult={getDepartments}
          />
        ) : (
          <Stack>
            <PrimaryButton
              onClick={() => navigate(`/category/department/form`)}
              startIcon={<AddButtonIcon />}
            >
              부서 추가
            </PrimaryButton>
            <Box />
          </Stack>
        )}
      </Stack>
      <Stack flex={1}>
        <DetailedSearch
          placeholder="부서명 검색"
          onKeyDown={e => {
            if (e.key === 'Enter') {
              setSearch(e.target.value);
            }
          }}
          onClick={(e, value) => {
            setSearch(value);
          }}
        />
      </Stack>
      {isEmpty ? (
        <Empty />
      ) : (
        <PrettyScrollbarTableWrap>
          <TableContainer
            component={Paper}
            sx={{ mt: '16px !important', maxHeight: '412px' }}
          >
            <PrimaryBorderTable sx={{ minWidth: 910 }} size="small">
              <TableHead>
                <TableRow>
                  {_.map(departmentHeader, t => (
                    <TableCell align="center" key={t.id}>
                      {t?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(departments, department => {
                  const isDefault = _.get(department, 'title') === '기타';
                  return (
                    <TableRow key={department.departmentId}>
                      <TableCell align="center">
                        {department?.title || ''}
                      </TableCell>
                      <TableCell align="center">
                        {fDate(department?.createdAt, 'yyyy-MM-dd') || '-'}
                      </TableCell>
                      <MaxWidthCell align="center">
                        {department?.description || '-'}
                      </MaxWidthCell>
                      <TableCell align="center">
                        {mdUp ? (
                          <EditCategoryButton
                            label="관리부서 수정"
                            form={form}
                            children={
                              <EditDepartmentForm
                                form={form}
                                departmentId={department?.departmentId}
                              />
                            }
                            category="department"
                            categoryId={department?.departmentId}
                            getResult={getDepartments}
                          />
                        ) : (
                          <TableButton
                            onClick={() => {
                              navigate(
                                `/category/department/${department?.departmentId}/form`,
                              );
                            }}
                          >
                            수정
                          </TableButton>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {isDefault ? (
                          <></>
                        ) : (
                          <DeleteCategoryButton
                            category="department"
                            categoryId={department?.departmentId}
                            getResult={getDepartments}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </PrimaryBorderTable>
          </TableContainer>
        </PrettyScrollbarTableWrap>
      )}
    </Stack>
  );
}
